import { getFundLogoPath, MockFundAmc } from '../../../../data/mockUtils'
import type { HarvestingPlanFund } from '../../components/plan/PlanFund'

export const planMockFunds: HarvestingPlanFund[] = [
  {
    isin: 'INF879O01027',
    fundLogo: getFundLogoPath(MockFundAmc.AXIS),
    fundName: 'Axis Small Cap - Growth',
    fundNature: 'Equity',
    fundCategory: 'Small Cap',
    bookGain: 45000,
    saveTax: 5625,
    rank: 2,
    fundPerformance: 'IN_FORM'
  },
  {
    isin: 'INF879O01028',
    fundLogo: getFundLogoPath(MockFundAmc.QUANT_MONEY_MANAGERS),
    fundName: 'Quant Small Cap - Growth',
    fundNature: 'Equity',
    fundCategory: 'Small Cap',
    bookGain: 69310,
    saveTax: 7539,
    rank: 2,
    fundPerformance: 'IN_FORM'
  },
  {
    isin: 'INF879O01029',
    fundLogo: getFundLogoPath(MockFundAmc.NIPPON_LIFE_INDIA),
    fundName: 'Nippon Small Cap - Growth',
    fundNature: 'Equity',
    fundCategory: 'Small Cap',
    bookGain: 23000,
    saveTax: 2875,
    rank: 13,
    fundPerformance: 'ON_TRACK'
  }
]
